import { render, staticRenderFns } from "./VoiceAgentChannels.vue?vue&type=template&id=0eae0cb2&scoped=true"
import script from "./VoiceAgentChannels.vue?vue&type=script&lang=js"
export * from "./VoiceAgentChannels.vue?vue&type=script&lang=js"
import style0 from "./VoiceAgentChannels.vue?vue&type=style&index=0&id=0eae0cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eae0cb2",
  null
  
)

export default component.exports